import Glide from '@glidejs/glide';

/**
 * @module GlideInitializer
 *
 */
(function GlideInitializer() {
        function GlideInitializer(dom) {
            /**
             * // local object availability
             * @private
             */
            var _this = this;

            /**
             * @type {object}
             */
            this.dom = dom;

            this.toggleButton = _this.dom.querySelector('.js-autoplay-toggle');
            this.configuration = {};

            /**
             * @method init
             * @returns {undefined}
             */
            this.init = function () {
                _this.configuration = _this.buildConfiguration(_this.dom.dataset.configuration);
                var slides = _this.dom.querySelectorAll('.glide__slide');

                if (slides.length > 0) {
                    var glide = new Glide(_this.dom, _this.configuration);
                    _this.setRealTimeEvents(glide, slides);
                    _this.setVisibleSlidesEvents(glide);

                    glide.on('mount.before', function () {
                        if (slides.length > 1 && _this.configuration?.autoplay) {
                            _this.setupIntersectionObserver(glide);
                            _this.setupAutoplayControl(glide);
                        }
                    });
                }
                glide.mount();
            };

            /**
             * @param configuration
             * @return {JSON}
             */
            this.buildConfiguration = function (configuration) {
                var givenConfig = JSON.parse(configuration);
                var glideConfiguration = {};
                var breakpointsConfiguration = {};

                if (givenConfig.hasOwnProperty('default')) {
                    glideConfiguration = givenConfig.default;
                }

                if (givenConfig.hasOwnProperty('tabletSize') && givenConfig.hasOwnProperty('tablet')) {
                    breakpointsConfiguration[givenConfig.tabletSize] = givenConfig.tablet;
                }

                if (givenConfig.hasOwnProperty('phoneSize') && givenConfig.hasOwnProperty('phone')) {
                    breakpointsConfiguration[givenConfig.phoneSize] = givenConfig.phone;
                }

                glideConfiguration['breakpoints'] = breakpointsConfiguration;

                return glideConfiguration;
            };

            /**
             * Disable sliding, if not enough slides are available
             * @param glide
             * @param slides
             */
            this.setRealTimeEvents = function (glide, slides) {
                glide.on('mount.after', function () {
                    if (slides.length <= glide._o.perView) {
                        glide.disable();
                    }
                });

                glide.on('resize', function () {

                    if (slides.length <= glide._o.perView) {
                        if (glide.index !== 0) {
                            glide.go('=0');
                        }
                        glide.disable();
                    } else {
                        glide.enable();
                    }
                });
            };

            /**
             * Set custom class for all visible slides
             * @param glide
             */
            this.setVisibleSlidesEvents = function (glide) {
                var updateVisibleSlides = function () {
                    var slides = Array.prototype.slice.call(glide.selector.querySelectorAll('.glide__slide'));
                    var activeSlide = glide.selector.querySelector('.glide__slide--active');
                    var perView = glide.settings.perView || 1;
                    var visibleSlides = [];

                    if (activeSlide) {
                        var currentSlide = activeSlide;
                        for (var i = 0; i < perView; i++) {
                            if (currentSlide) {
                                visibleSlides.push(currentSlide);
                                currentSlide = currentSlide.nextElementSibling;
                            }
                        }
                    }

                    var visibleIndices = visibleSlides.map(function (slide) {
                        return slides.indexOf(slide);
                    });

                    var originalSlideCount = slides.length;
                    if (glide._c && glide._c.Clones && glide._c.Clones.items) {
                        originalSlideCount = slides.length - (glide._c.Clones.items.length);
                    }

                    var getLogicalIndex = function (index) {
                        if (originalSlideCount === slides.length) return index;
                        var numStartClones = Math.floor((slides.length - originalSlideCount) / 2);
                        var logical = index - numStartClones;
                        while (logical < 0) logical += originalSlideCount;
                        return logical % originalSlideCount;
                    };

                    var visibleLogicalIndices = visibleIndices.map(getLogicalIndex);

                    slides.forEach(function (slide, index) {
                        var logicalIndex = getLogicalIndex(index);
                        var isVisible = visibleLogicalIndices.indexOf(logicalIndex) !== -1;
                        slide.classList.toggle('glide__slide--visible', isVisible);
                    });
                };

                glide.on(['mount.after', 'run', 'run.after', 'resize', 'move.after', 'translate.jump'], updateVisibleSlides);
            };

            /**
             * Intersection Observer
             * @param glide
             */
            this.setupIntersectionObserver = function (glide) {
                var observer = new IntersectionObserver(function (entries) {
                        entries.forEach(entry => {
                        _this.toggleButton.classList.toggle('pause', !entry.isIntersecting);
                        if (entry.isIntersecting) {
                            glide.play();
                        } else {
                            glide.pause();
                        }
                    });
                    },
                    {
                        root: null,
                        rootMargin: "20px",
                        threshold: 0.8,
                    });

                observer.observe(_this.dom);
            };

            /**
             * Autoplay control
             * @param glide
             */
            this.setupAutoplayControl = function (glide) {
                _this.toggleButton.addEventListener('click', function () {
                    var isPaused = _this.toggleButton.classList.toggle('pause');
                    if (isPaused) {
                        glide.pause();
                    } else {
                        glide.play();
                    }
                });
            };
            _this.init();
        }

        // define the global scope
        if (!window.TechDivisionCarousel) {
            window.TechDivisionCarousel = {};
        }

        window.TechDivisionCarousel.GlideInitializer = GlideInitializer;
    }
)
();

function tdCarouselReady(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', fn);
    } else {
        document.attachEvent('onreadystatechange', function () {
            if (document.readyState !== 'loading')
                fn();
        });
    }
}


function tdCarouselLoader() {
    var carousels = document.querySelectorAll('.glide');
    if (carousels.length > 0) {
        for (var i = 0; i < carousels.length; ++i) {
            var currentCarousel = carousels[i];
            var slides = currentCarousel.querySelectorAll('.glide__slide');

            // Instantiating a Class only when the carousel has slide(s)
            if (slides.length > 1) {
                window.TechDivisionCarousel.GlideInitializer(currentCarousel);
            }
        }
    }
}

tdCarouselReady(tdCarouselLoader);
